import { OrnamentDivider, LogoMark } from "./Ornaments";
import LanguageToggle from "./LanguageToggle";

const AuthShell = ({ children, footer }) => (
  <div className="suffa-page auth-page">
    <main className="auth-main">
      <div className="auth-wrap">
        <section className="auth-card" data-testid="auth-card">
          <div className="auth-lang-row">
            <LanguageToggle />
          </div>
          <a href="/" className="auth-logo" data-testid="auth-logo" aria-label="Suffa Matrimony home">
            <LogoMark size={44} />
            <span className="auth-logo-text">
              <span className="auth-logo-name">Suffa</span>
              <span className="auth-logo-sub">Matrimony</span>
            </span>
          </a>
          <div className="auth-ornament" aria-hidden="true">
            <OrnamentDivider />
          </div>
          {children}
        </section>
        {footer}
      </div>
    </main>
  </div>
);

export default AuthShell;
